import { useMemo } from "react";

import { ColumnsType } from "antd/es/table";
import { useIntl } from "react-intl";

import { AnyEntity, EntityType } from "@mapmycustomers/shared/types/entity";

import { OnPreview } from "@app/scene/reports/components/Overview/types/onPreview";
import { EntityTypeSupportedInOverviewPreview } from "@app/scene/reports/types/EntityTypeSupportedInOverviewPreview";

import { ColumnsFactory } from "./ColumnsFactory";
import { createActivityListColumns } from "./createActivityListColumns";
import { createCompanyListColumns } from "./createCompanyListColumns";
import { createDealListColumns } from "./createDealListColumns";
import { createPersonListColumns } from "./createPersonListColumns";
import { createRouteListColumns } from "./createRouteListColumns";

const columnFactoryMap: Record<EntityTypeSupportedInOverviewPreview, ColumnsFactory> = {
  [EntityType.ACTIVITY]: createActivityListColumns as ColumnsFactory,
  [EntityType.COMPANY]: createCompanyListColumns as ColumnsFactory,
  [EntityType.DEAL]: createDealListColumns as ColumnsFactory,
  [EntityType.PERSON]: createPersonListColumns as ColumnsFactory,
  [EntityType.ROUTE]: createRouteListColumns as ColumnsFactory,
};

export const useEntityListColumns = (
  entityType: EntityTypeSupportedInOverviewPreview,
  onPreview: OnPreview
): ColumnsType<AnyEntity> => {
  const intl = useIntl();
  return useMemo(
    () => columnFactoryMap[entityType](intl, onPreview),
    [entityType, intl, onPreview]
  );
};
